"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSetCollectionSizeArgsSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getSetCollectionSizeArgsSerializer() {
    return (0, serializers_1.struct)([['size', (0, serializers_1.u64)()]], {
        description: 'SetCollectionSizeArgs',
    });
}
exports.getSetCollectionSizeArgsSerializer = getSetCollectionSizeArgsSerializer;
//# sourceMappingURL=setCollectionSizeArgs.js.map